/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取我绑定的第三方账户列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.AccountBindingDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/setting/account/bindings`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
